/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2015-10-14
 * http相关的常量
 */

// 请求方法类型
export const REQUEST_METHODS = {
  GET   : 'GET',
  POST  : 'POST',
  PUT   : 'PUT',
  PATCH : 'PATCH',
  DELETE: 'DELETE',
  HEAD  : 'HEAD'
};

export const APPLICATION_JSON = 'application/json';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/constants/http-constants.js
 **/